// Departman adları ekranda Türkçe gösterilir; kayıtlı/filtre değerleri (İngilizce)
// değişmeden kalır ki kaydetme, filtreleme ve drill-down bağlantıları çalışmaya devam etsin.
export const DEPARTMENT_TR = {
  accounting: 'Muhasebe',
  finance: 'Finans',
  'food and beverage': 'Yiyecek İçecek',
  'front desk': 'Ön Büro',
  'guest relations': 'Misafir İlişkileri',
  'head office': 'Genel Müdürlük',
  housekeeping: 'Kat Hizmetleri',
  'human resources': 'İnsan Kaynakları',
  'information technology': 'Bilgi Teknolojileri',
  'internal audit': 'İç Denetim',
  kitchen: 'Mutfak',
  purchasing: 'Satın Alma',
  'quality control': 'Kalite Kontrol',
  reservation: 'Rezervasyon',
  'sales & marketing': 'Satış & Pazarlama',
  'technical services': 'Teknik Servis',
};

// Tek bir departman adını Türkçeleştirir; eşleşme yoksa orijinali döndürür.
export const translateDepartment = (name) => {
  if (name == null) return name;
  const key = String(name).trim().toLowerCase();
  return DEPARTMENT_TR[key] || name;
};

// Virgülle ayrılmış çoklu departman metnini Türkçeleştirir.
export const translateDepartments = (value) => {
  if (!value) return value;
  return String(value)
    .split(',')
    .map((part) => translateDepartment(part.trim()))
    .filter(Boolean)
    .join(', ');
};
